module.exports = __webpack_public_path__ + "gu.svg?beb28cdd728df39cc5016605a594cc99";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/gu.svg
// module id = 1392
// module chunks = 0